<template>
  <div class="visitors">
    <!-- 围观人数 @click="tapVisitors"-->
    <div class="gather" v-if="visitors">
      <div class="gather_ct">
        <span class="gather_count">{{total}}</span>
        <span class="gather_txt">{{showname}}人数</span>
      </div>
      <div class="gather_heads">
        <div v-for="(item,index) in visitors.list" :key="index">
          <div v-if="index==0">
            <img
              v-lazy="item.headimgurl ? item.headimgurl : 'http://assets.rurushishi.com/yq-rs-make/huafa/default-head.png' "
            />
          </div>
          <div v-else-if="index<6" class="head2">
            <img v-lazy="item.headimgurl" />
          </div>
          <div v-else-if="index==6" class="head2" @click="goMore()">
            <img v-lazy="item.headimgurl" />
            <div class="head8">. . .</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      showname: "",
      total: "",
      visitors: null
    };
  },
  watch: {},
  computed: {
    ...mapState(["pageInfo", "receiveSpreadInfo"])
  },
  methods: {
    goMore() {
      if (util.checkIsHuafa()) {
        return;
      }
      let url = "";
      if (util.getUrlRemoveParams(location.href).indexOf("t7") > -1) {
        // lj11
        url = `${location.protocol}//${location.host}/h5/t7_visitors`;
        url += `?id=${this.receiveSpreadInfo.id}`;
        url += `&psn=${this.receiveSpreadInfo.psn}`;
      } else {
        // lj10
        url = `${location.protocol}//${location.host}/h5/t9_visitors`;
      }
      util.openYqRsMakeLink(url);
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      comreq
        .listPageBrowserDetails(parseInt(this.pageInfo.PageId))
        .then(data => {
          if (data.code == 0 && data.obj && data.obj.total > 0) {
            this.visitors = data.obj;
            if (util.checkIsHuafa()) {
              if (data.obj.total >= 7) {
                this.total = data.obj.total + 2000;
              } else {
                this.total = data.obj.total;
              }
            } else if (location.host.indexOf("xtzfh") > -1) {
              if (parseInt(this.pageInfo.PageId) == 145050) {
                this.total = data.obj.total + 6000;
              } else {
                this.total = data.obj.total + 3000;
              }
            } else if (
              myVue.global.SUBDOMAIN == "ysdczj" &&
              parseInt(this.pageInfo.PageId) == 146763
            ) {
              this.total = data.obj.total + 956;
            } else if (
              myVue.global.SUBDOMAIN == "rdjt" &&
              parseInt(this.pageInfo.PageId) == 147253
            ) {
              this.total = data.obj.total + 5000;
            } else {
              this.total = data.obj.total;
            }
          }
          console.log("围观人数", data.obj);
        });
    });
  },
  mounted() {
    if (location.host.indexOf("hllsq.") > -1) {
      this.showname = "想买";
    } else {
      this.showname = "围观";
    }
  }
};
</script>
<style lang="css" scoped>
/* 围观 */

.gather {
  background-color: #fff;
  padding: 0 0.5rem;
  display: flex;
}

.gather_ct {
  text-align: center;
  padding-right: 0.5rem;
  padding-top: 0.14rem;
}

.gather_ct span {
  display: block;
}

.gather_count {
  font-size: 0.425rem;
  font-weight: 600;
}

.gather_txt {
  font-size: 0.3rem;
}

.gather_heads {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: ;
}

.gather_heads img {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  border: 1px solid #fff;
}

.gather_heads > div {
  /*display: inline-block;*/
}

.gather_heads .head2 {
  margin-left: -0.25rem;
  position: relative;
}

.gather_heads .head8 {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background-color: #000;
  opacity: 0.7;
  position: absolute;
  top: 0;
  color: #fff;
  text-align: center;
  font-weight: 800;
  border: 1px solid #fff;
  line-height: 0.65rem;
}
</style>